import { Navigate, Outlet, useLocation } from "react-router-dom";
import { authService } from "@/services/auth";
import type { ReactNode } from "react";

/**
 * AuthGuard — protege rotas internas.
 * Se o usuário não está autenticado, redireciona para /login guardando a
 * rota solicitada (redirect-back pós-login — QA observação 2: acessar
 * /cadastros deslogado devolvia para /geral em vez da rota pedida).
 * Pode ser usado como layout route (<Outlet />) ou como wrapper wrapper (children).
 */
export const REDIRECT_AFTER_LOGIN_KEY = "nipsys:redirect-after-login";

export default function AuthGuard({
  children,
  allowedMenuProfiles,
}: {
  children?: ReactNode;
  allowedMenuProfiles?: Array<"platform" | "tenant_admin" | "user">;
}) {
  const location = useLocation();
  const currentUser = authService.getUser();
  const currentMenuProfile =
    typeof authService.getMenuProfile === "function"
      ? authService.getMenuProfile()
      : currentUser?.menuProfile || "user";
  if (!authService.isAuthenticated()) {
    try {
      sessionStorage.setItem(
        REDIRECT_AFTER_LOGIN_KEY,
        `${location.pathname}${location.search}${location.hash}`,
      );
    } catch { /* sessionStorage indisponível — segue sem redirect-back */ }
    return <Navigate to="/login" replace />;
  }
  if (allowedMenuProfiles && !allowedMenuProfiles.includes(currentMenuProfile)) {
    return <Navigate to="/geral" replace />;
  }
  return children ? <>{children}</> : <Outlet />;
}
